import Cookies from 'js-cookie'

/** Microba user token cookie name */
const MICROBA_TOKEN_COOKIE_NAME = 'microba_portal_user_refresh_token'

/** The domain of Microba products */
const MICROBA_DOMAIN = 'microba.com'

/**
 * Save the user token as a domain specific cookie
 *
 * @param token Token to save
 * @returns boolean of success saving cookie or not
 */
export function saveRefreshTokenAsCookie(token) {
  try {
    // create expiry time
    const inSixtySecondsFromNow = new Date(Date.now() + 1000 * 60)

    // set a cookie to the microba domain with the users access token
    Cookies.set(MICROBA_TOKEN_COOKIE_NAME, token, {
      expires: inSixtySecondsFromNow, //set expiry
      domain: MICROBA_DOMAIN // set the domain to microba domain
    })
    return true
  } catch {
    return false
  }
}

/**
 * Delete all Microba user token cookies
 * @returns boolean of success deleting cookie
 */
export function deleteMicrobaRefreshTokenCookie() {
  try {
    Cookies.remove(MICROBA_TOKEN_COOKIE_NAME)
    return true
  } catch {
    return false
  }
}

/**
 * Get the refresh token that is stored in a cookie if one exists.
 *
 * @returns the refresh token or null
 */
export function getMicrobaRefreshTokenFromCookie() {
  try {
    // get the token
    const refreshToken = Cookies.get(MICROBA_TOKEN_COOKIE_NAME)
    // check the cookie is there
    if (typeof refreshToken !== 'string') throw Error('No refresh token cookie.')
    return refreshToken //return the cookie
  } catch {
    // fail silenty and return null
    return null
  }
}
